const serverStorage = {
  setItem(_key, value) {
    return value;
  },
  getItem(_key) {
    return null;
  },
  removeItem(_key) {
    return null;
  },
  clear() {
    return null;
  },
};

class Storage {
  storage = null;

  constructor(storage = null) {
    this.storage = storage;
  }

  set(key, value) {
    return this.storage.setItem(key, JSON.stringify(value));
  }

  get(key, fallback = null) {
    const data = this.storage.getItem(key);

    if (!data) {
      return fallback;
    }

    return JSON.parse(data);
  }

  forget(key) {
    return this.storage.removeItem(key);
  }

  clear() {
    return this.storage.clear();
  }
}

export default new Storage(typeof window === 'undefined' ? serverStorage : window.localStorage);
